export const idleTimerSeconds = 480 //8 minutes
export const logoutTimerSeconds = 120
